'use strict';

/**
 * Global modules.
 */
const Swiper = global.Swiper = require('swiper/swiper-bundle.min.js');
const debounce = require('lodash/debounce');

/**
 * Global constants.
 */
const swipers = [];

/**
 * Adjusts the number of visible slides and slides per group based on the container's width.
 * @param {Object} sliderEl - The Swiper instance or slider object.
 */
function adjustSlides(sliderEl) {
    if (!sliderEl || !sliderEl.el) {
        return;
    }

    let slidesPerView = Math.floor(sliderEl.el.clientWidth / sliderEl.swatchWidth);

    if (sliderEl.slides.length <= slidesPerView) {
        sliderEl.el.swiper.destroy(true, true);
        return;
    }

    slidesPerView = Math.floor(sliderEl.width / sliderEl.swatchWidth);
    // eslint-disable-next-line no-param-reassign
    sliderEl.params.slidesPerView = slidesPerView;
    // eslint-disable-next-line no-param-reassign
    sliderEl.params.slidesPerGroup = slidesPerView;
    sliderEl.update();
}

/**
 * Initializes and restores swiper for swatch gallery.
 * @param {JQuery} $container - The modal swiper container.
 */
function initColorSwatchSwiper($container = $(document)) {
    const $selector = $container.find('.swiper-container--swatches:not(.swiper-initialized)');

    $selector.each(function () {
        const $swiperEl = $(this);
        const $colorSwatches = $swiperEl.find('.js-color-swatch');
        const containerWidth = $swiperEl.width();
        const swatchWidth = $colorSwatches.first().outerWidth(true);
        const isSwatchesFitContainer = containerWidth >= $colorSwatches.length * swatchWidth;

        if (!isSwatchesFitContainer) {
            const swiperData = {
                loop: false,
                slidesPerView: 'auto',
                slidesPerGroupAuto: true,
                watchOverflow: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                on: {
                    resize: debounce(adjustSlides, 300),
                    afterInit: function () {
                        this.swatchWidth = swatchWidth;
                        adjustSlides(this);
                    }
                }
            };

            swipers.push(new Swiper(this, swiperData));
        }
    });
}

/**
 * Initializes and restores swiper instance for image gallery.
 * @param {Element} swiperContainer - The modal swiper container.
 */
function initTileImageSwiperInstance(swiperContainer) {
    if (swiperContainer.swiper) {
        return;
    }

    const swiperInstance = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        lazy: {
            loadPrevNext: true,
            loadOnTransitionStart: true
        }
    });

    swipers.push(swiperInstance);
}

const observerOptions = {
    root: null,
    threshold: 0.1
};

const swiperObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            initTileImageSwiperInstance(entry.target);
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);

/**
 * Initializes and restores swiper for image gallery.
 * @param {JQuery} $container - The modal swiper container.
 */
function initTileImageSwiper($container = $(document)) {
    const $selector = $container.find('.image-carousel-enabled .selected .swiper-container--images:not(.swiper-initialized)');

    $selector.each(function () {
        swiperObserver.observe(this);
    });
}

module.exports = {
    init: function ($selector = $('.swiper-container[data-swiper]')) {
        $selector.each(function () {
            if (!this.swiper) {
                const $el = $(this);
                const swOptions = $el.data('swiper');

                swOptions.on = Object.assign({}, swOptions.on, {
                    init: function () {
                        $el.addClass('swiper-loaded');
                    }
                });

                $el.on('updateLazyImages', function () {
                    if (this.swiper) {
                        const $images = $(this).find('.swiper-wrapper img');
                        $images.each(function () {
                            if (!this.hasAttribute('src') && this.getAttribute('data-src')) {
                                this.setAttribute('src', this.getAttribute('data-src'));
                            }
                        });
                    }
                });

                swipers.push(new Swiper(this, swOptions));
            }
        });
    },
    destroy: function ($selector) {
        if (!$selector) {
            return;
        }

        $selector.each(function () {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
        });
    },
    initColorSwatchSwiper: initColorSwatchSwiper,
    initTileImageSwiper: initTileImageSwiper,
    handleEvents: function () {
        $(window).on('resize', debounce(function () {
            initColorSwatchSwiper();
        }, 300));

        $(document).on('search:productGridUpdated', function () {
            initColorSwatchSwiper();
            initTileImageSwiper();
        });
    }
};
